import * as React from 'react';
import './PVABadge.css';

interface PVADiamondProps {
    style?: string;
    step: number;
    onClick?: () => void;
}

export class PVADiamond extends React.Component<PVADiamondProps, {}> {
    constructor(props: PVADiamondProps) {
        super(props);
    }

    render() {
        var clsName = 'pva-diamond';
        var stepNames = ['one', 'two', 'three', 'four'];
        for (var i = 0; i < this.props.step && i < stepNames.length; i++) {
            clsName += ' ' + stepNames[i];
        }

        return (
            <div onClick={this.props.onClick ? this.props.onClick : () => { return; }} className={`${clsName} ${this.props.style}`}>
                <svg width="40px" height="40px" viewBox="0 0 40 40" version="1.1">
                    <defs/>
                    <g className="Latest" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                        <g className="PVA-Style" transform="translate(-346.000000, -433.000000)">
                            <g className="Group-6" transform="translate(330.000000, 422.000000)">
                                <g className="Diamond" transform="translate(16.000000, 11.000000)">
                                    <path className="Diamond-Top-Left" d="M7.92069212,14.9968782 L21.4770931,1.4404772 C21.9241591,1.89423361 22.119404,2.47723182 22.0628277,3.18947184 L22.0628277,26.8849558 C22.0969588,27.5828366 21.9016168,28.1388473 21.4768018,28.5529878 L7.92069212,14.9968782 Z" fill="#C4CDD5" transform="translate(14.996527, 14.996733) scale(-1, -1) rotate(45.000000) translate(-14.996527, -14.996733) "/>
                                    <path className="Diamond-Top-Right" d="M17.9206921,14.9968782 L31.4770931,1.4404772 C31.9241591,1.89423361 32.119404,2.47723182 32.0628277,3.18947184 L32.0628277,26.8849558 C32.0969588,27.5828366 31.9016168,28.1388473 31.4768018,28.5529878 L17.9206921,14.9968782 Z" fill="#F4F6F8" transform="translate(24.996527, 14.996733) scale(1, -1) rotate(45.000000) translate(-24.996527, -14.996733) "/>
                                    <path className="Diamond-Bottom-Left" d="M7.92069212,24.9968782 L21.4770931,11.4404772 C21.9241591,11.8942336 22.119404,12.4772318 22.0628277,13.1894718 L22.0628277,36.8849558 C22.0969588,37.5828366 21.9016168,38.1388473 21.4768018,38.5529878 L7.92069212,24.9968782 Z" fill="#8899AA" transform="translate(14.996527, 24.996733) scale(-1, 1) rotate(45.000000) translate(-14.996527, -24.996733) "/>
                                    <path className="Diamond-Bottom-Right" d="M17.9206921,24.9968782 L31.4770931,11.4404772 C31.9241591,11.8942336 32.119404,12.4772318 32.0628277,13.1894718 L32.0628277,36.8849558 C32.0969588,37.5828366 31.9016168,38.1388473 31.4768018,38.5529878 L17.9206921,24.9968782 Z" fill="#C4CDD5" transform="translate(24.996527, 24.996733) rotate(45.000000) translate(-24.996527, -24.996733) "/>
                                </g>
                            </g>
                        </g>
                    </g>
                </svg>
            </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/reports/blocks/PVADiamond.tsx